import { takeLatest, put, select } from 'redux-saga/effects';
import { createAxios, logNative } from '../utils/utils';

import { cacheKeys } from '../constants/storageKeys';
import { AIGC_GET_REPLY_9010, AIGC_GET_QUESTION_9010 } from '../config';
import {
  AICG_GET_REPLYS,
  AICG_GET_REPLYS_SUCCESS,
  AICG_GET_QUESTION,
  AICG_GET_QUESTION_SUCCESS,
  AICG_REPLY_IS_BUSING,
  AICG_SAVE_PREV_CONTEXT,
} from '../constants/aigc';

function* fetchAiGetReplys(param) {
  try {
    // 拿去当前最新回答
    const aigcReplys = yield select(state => state.aigc.aigcReplys);
    const aigcIsChangeReply = yield select(state => state.aigc.aigcIsChangeReply);

    // 添加用户发送的内容
    let userQuestion = {
      chatType: 'usertext',
      h5IDAll: +new Date(),
      userText: param?.data?.userText || '换一批',
    };
    if (param?.data?.isReAnswer != true) {
      yield put({
        type: AICG_GET_REPLYS_SUCCESS,
        data: userQuestion,
      });
    }

    const machineInfo = JSON.parse(localStorage.getItem(cacheKeys.LOCALMACHINE_INFO));
    let timestamp = +new Date();
    // 开始请求回复数据
    let postParams = {
      appID: machineInfo?.ludp_uuid || +new Date(),
      userText: param?.data?.userText,
      timestamp: timestamp,
      context: aigcReplys?.context || {},
      isFresh: false,
    };

    // 是否为重新回答
    if (param?.data?.isReAnswer) {
      // 是重新回答, userQuestion.userText 重新赋值, 因为param没有传递userText
      userQuestion.userText = aigcReplys?.userQuestion?.userText;
      postParams.userText = aigcReplys?.userQuestion?.userText;
      postParams.context = aigcReplys?.context || {};
      postParams.isFresh = true;

      // 是重新回答, 则先加一个假数据给 aigcReplys  AICG_GET_REPLYS_SUCCESS
      let replys = {
        chatType: 'reply',
        isReAnswer: true,
        isReAnswering: 1, // 1: 正在请求重新回答  2: 重新回答请求成功
        reAnswer: param?.data?.reAnswer,
      };
      yield put({ type: AICG_GET_REPLYS_SUCCESS, data: replys });
    }

    // 设置状态为请求中
    yield put({
      type: AICG_REPLY_IS_BUSING,
      data: { isBusing: 1 },
    });

    // 当点击了左右切换回答后, 设置context为切换后的context
    if (aigcIsChangeReply && aigcIsChangeReply?.h5IDAll && aigcIsChangeReply?.context) {
      postParams.context = aigcIsChangeReply?.context;
    }

    const axios = yield createAxios('isAIGC', {
      userText: postParams.userText || '换一批',
      timestamp,
    });

    logNative(`AIGC 请求回答 参数`, { ...postParams, context: null });
    const res = yield axios.post(AIGC_GET_REPLY_9010, {
      ...postParams,
    });

    // 当点击了左右切换回答后, 请求完成之后, 设置aigcIsChangeReply为空
    if (aigcIsChangeReply && aigcIsChangeReply?.h5IDAll && aigcIsChangeReply?.context) {
      yield put({
        type: AICG_SAVE_PREV_CONTEXT,
        data: {},
      });
    }

    // 请求完成发现, 判断当前状态为点击了暂停回答, 则不走下面的逻辑
    const isBusing = yield select(state => state.aigc.isBusing);
    if (isBusing === 4) {
      return;
    }

    // 请求成功则添加回复数据
    if (res?.data?.status === 0) {
      const data = {
        ...res.data.data,
        chatType: 'reply',
        isReAnswer: false,
        postParams: postParams,
        userQuestion,
        timeId: +new Date(),
      };

      if (param?.data?.isReAnswer) {
        data.isReAnswering = 2; // 1: 正在请求重新回答  2: 重新回答请求成功
        data.isReAnswer = true;
        data.reAnswer = param?.data?.reAnswer;
      }
      yield put({ type: AICG_GET_REPLYS_SUCCESS, data });
      yield put({
        type: AICG_GET_QUESTION_SUCCESS,
        data: res?.data?.data?.relatedQuestions ? [...res?.data?.data?.relatedQuestions] : [],
      });
    } else {
      let replys = {
        h5IDAll: +new Date(),
        context: aigcReplys?.context || {},
        userQuestion,
        chatType: 'reply',
        isError: true,
        replys: [
          {
            h5ID: +new Date(),
            writing: 2,
            commandCode: '1010', // 1001 添加下载任务完成, 1010接口请求错误
            commandId: '1010',
            commandMsg: {
              tip: '请求失败，请重试！',
              title: '',
              detailInfo: '',
            },
            bizInfo: '{a:1}',
          },
        ],
        question: null,
      };

      if (param?.data?.isReAnswer) {
        replys.isReAnswering = 2; // 1: 正在请求重新回答  2: 重新回答请求成功
        replys.isReAnswer = true;
        replys.reAnswer = param?.data?.reAnswer;
      }
      yield put({
        type: AICG_GET_REPLYS_SUCCESS,
        data: replys,
      });
    }
  } catch (error) {
    logNative(`AIGC 请求回答数据解析失败 ${error}`, error);
  }
}
export function* watchFetchAiGetReplys() {
  yield takeLatest(AICG_GET_REPLYS, fetchAiGetReplys);
}

function* fetchAiGetQuestion(param) {
  try {
    // 更新当前的相关问题与时间，用于避免二次请求
    const aigcRecoQuestion = yield select(state => state.aigc.aigcRecoQuestion);
    yield put({
      type: AICG_GET_QUESTION_SUCCESS,
      data: {
        ...aigcRecoQuestion,
        timeId: param.data.timeId,
        question: param?.data?.question,
      },
    });

    const machineInfoStr = localStorage.getItem(cacheKeys.LOCALMACHINE_INFO);
    const machineInfo = JSON.parse(machineInfoStr);
    let timestamp = +new Date();
    let postParams = {
      appID: machineInfo?.ludp_uuid,
      question: param?.data?.question,
      nonce: 2,
      timestamp: timestamp,
    };
    const axios = yield createAxios('isAIGC', {
      userText: param?.data?.question || '',
      timestamp,
    });
    const res = yield axios.post(AIGC_GET_QUESTION_9010, {
      ...postParams,
    });
    if (res?.data?.status === 0 && res?.data?.data) {
      const data = {
        ...res.data.data,
        postParams: postParams,
        timeId: param.data.timeId,
        question: param?.data?.question,
      };
      yield put({ type: AICG_GET_QUESTION_SUCCESS, data: data });
    }
  } catch (error) {
    logNative(`AIGC 请求回答的相关问题解析失败 ${error}`, error);
  }
}

export function* watchFetchAiGetQuestion() {
  yield takeLatest(AICG_GET_QUESTION, fetchAiGetQuestion);
}
